import React from "react";
import "../../styles/ERprotocols.css";
import { Helmet, HelmetProvider } from "react-helmet-async";

import { Link } from "react-router-dom";
const ERprotocols = () => {
  return (
    <div className="ER-container">
      <HelmetProvider>
        <Helmet>
          <title>
            Emergency Room Precautions for Neuromuscular Disease Patients | Safe
            Respiratory Care
          </title>
          <meta
            name="description"
            content="Critical emergency precautions for patients with neuromuscular disease. Learn about risks with anesthesia, oxygen therapy, and safe use of noninvasive ventilation to prevent hypercapnia and other complications."
          />
          <meta
            name="keywords"
            content="emergency room precautions, neuromuscular disease, muscular dystrophy, anesthesia risk, hypercapnia, EtCO2, BiPAP, noninvasive ventilation, oxygen therapy caution, malignant hyperthermia, tachycardia"
          />
          <meta name="author" content="DoctorBach" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta
            property="og:image"
            content="https://doctorbach.com/images/BachJohn.jpg"
          />
          <meta
            property="og:image"
            content="https://doctorbach.com/favicon.png"
          />
          <meta
            property="og:url"
            content="https://doctorbach.com/resources/er"
          />
          <meta property="og:type" content="article" />
        </Helmet>
      </HelmetProvider>
      <div className="precautions">
        <h3>Emergency Room Precautions</h3>
        <div className="er-pro">
          <h5>USE CAUTION in administering:</h5>
          <ul>
            <li>Anesthesia</li>
            <li>Narcotics </li>
            <li>Stimulants</li>
            <li>Supplemental O2</li>
          </ul>
          <h5>
            Be prepared to intubate! Patients with neuro-muscular disease are
            subject to...
          </h5>
          <ul>
            <li>Malignant Hyperthermia caused by certain anesthetics.</li>
            <li>
              Restrictive Lung Disease caused by weak respiratory muscles.
            </li>
            <li>Tachycardia (high pulse rate).</li>
            <li>
              Hypopnea (shallow breathing) and hypercapnia (CO2 retention).
            </li>
          </ul>
        </div>
        <div className="er-pro">
          <h4>Supplemental Oxygen</h4>
          <p>
            DO NOT administer supplemental O2 for sustained periods without
            CONSTANT monitoring of EtCO2 with a capnograph. EtCO2 greater than
            43 mmHg indicates CO2 retention. Administration of O2 can cause CO2
            to rise, resulting in hypercapnia, coma, and DEATH!
          </p>
          <p>
            Sustained hypercapnia (EtCO2 greater than 43) requires mechanical
            ventilatory assistance. Use noninvasive ventilation via mouthpiece
            or nasal interface with high-span Bi-PAP (typ. 18/2, rate 10) or
            volume vent (typ. 1000 ml, rate 10, command/assist mode). If
            unconcious, intubation may be required.
          </p>
          <div lassName="misc">
            <p>
              Also see:{" "}
              <Link
                to="https://pubmed.ncbi.nlm.nih.gov/7898136/"
                style={{ textDecoration: "none", color: "darkblue" }}
              >
                Severe hypercapnia after low-flow oxygen therapy.
              </Link>
            </p>
            <p>
              For additional information: contact Millennium at 1-800-269-9436 /
              (973) 463-1880.
            </p>
          </div>
        </div>
        <div className="er-pro">
          <h4>PDR - Verify Drug Side-Effects</h4>
          <p>
            Use the Physician's Desk Reference or{" "}
            <Link
              to="https://medlineplus.gov/druginformation.html"
              style={{ textDecoration: "none", color: "darkblue" }}
            >
              MedLine Plus Drug Information
            </Link>{" "}
            to verify known side-effects before administering drugs. Watch for
            warnings and cautions related to neuro-muscular disease, muscular
            dystrophy, malignant hyperthermia, lung disease, tachycardia, etc.
          </p>
        </div>
      </div>
      <div className="er-pro">
        <h4>Anesthetics</h4>
        <p
          style={{
            fontWeight: "bold",
            color: "black",
            fontSize: "14px",
          }}
        >
          General anesthesia is accompanied by a number of important risks. When
          general anesthesia is required in order to undergo a specific
          procedure, succinylcholine and inhalational anesthetics need to be
          AVOIDED.
        </p>
        <div lassName="misc">
          <p>
            Note: Patients with muscular dystrophy will likely have preexisting
            elevated CK level and tachycardia!
          </p>
        </div>
      </div>
      <div className="er-pro">
        <h4>Additional information</h4>

        <p>
          For more information about Care Protocols, click here for{" "}
          <Link
            to="/resources/op"
            style={{ textDecoration: "none", color: "darkblue" }}
          >
            Outpatient Protocols
          </Link>{" "}
          and{" "}
          <Link
            to="/resources/icu"
            style={{ textDecoration: "none", color: "darkblue" }}
          >
            Intensive Care Protocols.
          </Link>{" "}
        </p>
        <p>
          For more information about Air Stacking or Glossopharyngeal Breathing
          (GPB),{" "}
          <Link
            to="/resources/as"
            style={{ textDecoration: "none", color: "darkblue" }}
          >
            click here.
          </Link>{" "}
        </p>
      </div>
    </div>
  );
};

export default ERprotocols;
